import { createFileRoute } from '@tanstack/react-router';

import { AdminWhatsAppPage } from '@/features/admin/pages/AdminWhatsAppPage';

export const Route = createFileRoute('/_app/admin/whatsapp')({
  component: AdminWhatsAppPage,
});
